import React from 'react';

const Hero = () => {
  return (
    <section className="hero">
      <div className="container hero-frame">
        <img
          src="/images/hero-background.png"
          alt="Foodea"
          className="hero-img"
        />
        <div className="hero-content">
          {/* içerik buradaysa ayrı bir satıra alıp resmin altında gösterebilirsin */}
        </div>
      </div>

      <style jsx>{`
        .hero {
          display: block;
          padding: 2rem 0;
        }

        .hero-frame {
          width: 100%;
          margin: 0 auto;
        }

        .hero-img {
          display: block;
          width: 100%;
          height: auto;
          border-radius: min(28px, 4vw);
        }

        .hero-content {
          max-width: 800px;
          margin: 1.5rem auto 0;
          text-align: center;
          color: var(--white);
          padding: 0 1rem;
        }

        .hero h1 {
          font-size: clamp(2rem, 5vw, 3.5rem);
          font-weight: 700;
          margin-bottom: 1rem;
        }

        .hero p {
          font-size: clamp(1rem, 2.2vw, 1.2rem);
          opacity: 0.9;
        }

        @media (max-width: 992px) {
          .hero-img {
            border-radius: min(24px, 5vw);
          }
        }

        @media (max-width: 768px) {
          .hero {
            padding: 1.5rem 0;
          }
          .hero-img {
            border-radius: min(20px, 6vw);
          }
        }
      `}</style>
    </section>
  );
};

export default Hero;
